<template>
    <div class="pl-lg-4">
        <div v-if="customers.length > 1"  class="row">
            <div class="col mb-4">
                <label class="form-control-label">
                Organisation
                <span>*</span></label>
                <select v-model="cert.customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name }}
                    </option>
                </select>
                <small class="text-muted">Bitte wählen Sie hier die Organisation, innerhalb welcher das Zertifikat zum Einsatz kommt.</small>
            </div>
        </div>
        <div class="row">
            <div class="col mb-4">
                <base-input alternative=""
                            required
                            label="Bezeichnung"
                            placeholder="Interne Bezeichnung für das Zertifikat zur Wiedererkennung"
                            input-classes="form-control-alternative"
                            v-model="cert.name"
                />
                <small class="text-muted">Vergeben Sie eine beliebige Bezeichnung für das Zertifikat. Das Zertifikat wird mit diesem Namen z.B. in der Zertifikatsauswahl in den Standorteigenschaften angezeigt.</small>
            </div>
        </div>
        <fade-transition>
        <div v-if="cert.name !== ''" class="row">
            <div class="col mb-4">
                <base-input alternative=""
                            required
                            label="Zertifikatspasswort"
                            placeholder="Oasis Zertifikatspasswort"
                            input-classes="form-control-alternative"
                            v-model="cert.certPassword"
                />
                <small class="text-muted">Das Zertifikatspasswort finden Sie im Passwortbrief vom RP Darmstadt. In der Regel befindet sich das Passwort unter "1. Passwort Zertfikat". Geben Sie das Passwort mit den Bindestrichen "-" ein. Zum Beispiel: t0c4-lpn4-9j42-8404-5s46</small>
            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <h2 v-if="cert.certPassword !== null">Bitte laden Sie die notwendigen Zertifikate hoch</h2>
        </fade-transition>
        <fade-transition>
        <div v-if="cert.certPassword !== null" class="row">
            <div class="col mb-4">
                <label class="form-control-label">Root Zertifikat (Dateiendung: *.crt)
                    <input class="form-control form-control-alternative"  v-bind:class="{'success':(cert.rootCert !== '')}" type="file" accept=".crt,.123" id="rootcertfile" ref="rcfile" v-on:change="handleFileUpload('rcf')"/>
                </label>
                <p></p><small class="text-muted">Das Root-Zertifikat (Dateiendung: *.crt) erhalten Sie per E-Mail vom RP Darmstadt. Das Root-Zertifikat trägt die Bezeichnung "OASIS Root Zertifikat" im Dateinamen.</small>
            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div v-if="cert.certPassword !== null" class="row">
            <div class="col mb-4">
                <label class="form-control-label">Private Zertifikat (Dateiendung: *.p12)
                    <input class="form-control form-control-alternative" v-bind:class="{'success':(cert.privateCert !== '')}" type="file" accept=".p12,.123" id="privatecertfile" ref="pcfile" v-on:change="handleFileUpload('pcf')"/>
                </label>
                <p></p><small class="text-muted">Das Private-Zertifikat (Dateiendung: *.p12) erhalten Sie per E-Mail vom RP Darmstadt. Das Private-Zertifikat trägt die Vertragsnummer und den Namen Ihres Unternehmens im Dateinamen. Zum Beispiel: "DE-102345_2021_Meine_Spielhallenbetriebe_GmbH" </small>
            </div>

            <!---
            <div class="col-lg-2">
                <label class="form-control-label">Bitte hochloaden<br>
                    <base-button type="secondary" v-on:click.prevent="submitFiles()">Upload</base-button>
                </label>
            </div> --->
        </div>
        </fade-transition>
    </div>
</template>
<script>
    import axios from 'axios';
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    export default {
        name: 'certform',
        components:{FadeTransition},
        data(){
            return {
                cert: {
                    name: '',
                    email: "",
                    privateCert: '',
                    rootCert: '',
                    certPassword: null,
                    customer: null
                },
                rootCert: '',
                privateCert: ''
            }
        },
        created(){
            if (!this.$store.getters['customer/isReady']) {
                this.$store.dispatch('customer/getCustomerCollection');
            }

            this.cert.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
        },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
            customerData() {
                return (this.$store.getters['customer/isReady'] && this.cert.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.cert.customer) : null;
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        },
        methods:{
            handleFileUpload(type) {
                if (type === 'rcf') {
                    this.rootCert = this.$refs.rcfile.files[0];
                    if (this.rootCert.name.endsWith('.123')) {

                        this.rootCert = this.renameFile(this.rootCert,this.rootCert.name.replace('.123', ''))
                        /*
                        Object.defineProperty(this.rootCert, 'name', {
                            writable:true,
                            value:this.rootCert.name.replace('.123', '')
                        });
                        // eslint-disable-next-line no-console
                        console.log(this.rootCert.name)

                        */

                    }
                } else if (type === 'pcf') {
                    this.privateCert = this.$refs.pcfile.files[0];
                    if (this.privateCert.name.endsWith('.123')) {
                        this.privateCert = this.renameFile(this.privateCert,this.privateCert.name.replace('.123', ''))
                        /*
                        Object.defineProperty(this.privateCert, 'name', {
                            writable:true,
                            value:this.privateCert.name.replace('.123', '')
                        });
                        // eslint-disable-next-line no-console
                        console.log(this.privateCert.name) */
                    }
                }
            },
            submitFiles() {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('alert/clear');
                    if (this.rootCert === '' || this.privateCert === '') {
                        this.$store.dispatch('alert/error', 'Bitte Zertifikate auswählen');
                    } else {
                        Promise.all([this.submitPrivateFiles(), this.submitRootCAFiles()]).then((values) => {
                            resolve(values)

                        }).catch(error =>{
                            reject(error)
                        });
                    }
                })
            },
            submitRootCAFiles() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let formData = new FormData();
                    formData.append('file', this.rootCert);
                    axios.post(process.env.VUE_APP_API_SERVER + '/api/oasis_cert_objects',
                        formData,
                        {
                            headers:header
                        }
                    ).then(response => {
                        this.cert.rootCert = response.data['@id'];
                        resolve(response)
                        //this.$store.dispatch('alert/success', 'Root CA Zertifikat erfolgreich hochgeladen');
                    })
                        .catch(error => {
                            this.$store.dispatch('alert/error', error);
                            reject(error)
                        });
                });
            },
            submitPrivateFiles() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let formData = new FormData();
                    formData.append('file', this.privateCert);
                    axios.post(process.env.VUE_APP_API_SERVER + '/api/oasis_cert_objects',
                        formData,
                        {
                            headers:header
                        }
                    ).then(response => {
                        this.cert.privateCert = response.data['@id'];
                        resolve(response)
                        //this.$store.dispatch('alert/success','Privates Zertifikat erfolgreich hochgeladen');
                    })
                        .catch(error => {
                            this.$store.dispatch('alert/error', error);
                            reject(error)
                        });

                })
            },
            renameFile(originalFile, newName) {
                return new File([originalFile], newName, {
                    type: originalFile.type,
                    lastModified: originalFile.lastModified,
                });
            }
        }
    }
</script>

<style scoped>

    .success {
        background-color: #2dce89;
    }

</style>